var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ConnectionNames } from "../../Contracts";
import { ConfigStore } from "../Stores";
import { appendQueryParams, getUserId } from "../Helpers";
/**
 * Config for channel path and request method type.
 *
 * @namespace
 * @property {object} ConnectionNames - excluding Sportsbook
 * @property {object} ConnectionNames.MessageChannels
 * @property {string} ConnectionNames.MessageChannels.path
 * @property {HTTPRequestMethod} [ConnectionNames.MessageChannels.method="GET"]
 */
export const ChannelsConfig = {
    [ConnectionNames.betslip]: {
        CalculateBets: {
            path: "/betting/calculate/regularbets",
            method: "POST"
        },
        CalculateYourbetBets: {
            path: "/betting/calculate/yourbet",
            method: "POST"
        },
        PlaceBets: {
            path: "/betting/purchases",
            method: "POST"
        },
        UpdatePurchases: {
            path: "/betting/purchases",
            method: "PUT"
        },
        GetPurchases: {
            path: params => ({
                channel: appendQueryParams("/betting/purchases", params),
                params: undefined
            })
        }
    },
    [ConnectionNames.realityCheck]: {
        GetSettings: {
            path: "/interval"
        },
        SaveSettings: {
            path: "/interval",
            method: "POST"
        },
        GetWageringInformation: {
            path: "/wageringinformation"
        },
    },
    [ConnectionNames.player]: {
        GetPlayer: {
            path: params => ({
                channel: `/players/${getUserId(ConfigStore.config.connections.jwt)}`,
                params
            })
        },
        GetLimitsHistory: {
            path: params => ({
                channel: `/players/${getUserId(ConfigStore.config.connections.jwt)}/limitshistory`,
                params
            })
        }
    },
    [ConnectionNames.betsReporting]: {
        GetSettledBets: {
            path: "/bets/settled"
        }
    },
    [ConnectionNames.casino]: {
        GetCategories: {
            path: "/categories"
        },
        GetFreespins: {
            path: "/freespins"
        },
        GetGames: {
            path: (_a) => {
                var { categoryId } = _a, params = __rest(_a, ["categoryId"]);
                return ({
                    channel: `/categories/${categoryId}/games`,
                    params
                });
            }
        },
        GetLaunchParams: {
            path: "/game/launchParams"
        },
    },
    [ConnectionNames.captor]: {
        ReportsMetaData: {
            path: "/reportsmetadata",
            method: "POST"
        },
        Report: {
            path: "/report",
            method: "POST"
        },
        AnnualReport: {
            path: "/annualreport",
            method: "POST"
        },
    },
    [ConnectionNames.search]: {
        Search: {
            path: "/search"
        },
        PersonalizedEvents: {
            path: "/events/getpersonalizedprelivebysportId",
            method: "POST"
        },
        GetEvents: {
            path: "/events/getbyeventid",
            method: "POST"
        },
        GetLeagues: {
            path: "/leagues/getbyleagueid",
            method: "POST"
        }
    },
    [ConnectionNames.casinoPlayerActivity]: {
        GetLastBetAge: {
            path: "/"
        }
    },
    [ConnectionNames.tournaments]: {
        GetTournaments: {
            path: params => {
                var _a;
                return ({
                    channel: `/tournaments`,
                    params: Object.assign({ lang: (_a = ConfigStore.config.urls.TournamentsConnection) === null || _a === void 0 ? void 0 : _a.queryParams.locale }, params)
                });
            }
        },
        GetTournamentDetails: {
            path: (_a) => {
                var _b;
                var { id } = _a, params = __rest(_a, ["id"]);
                return ({
                    channel: `/tournaments/${id}/details`,
                    params: Object.assign({ lang: (_b = ConfigStore.config.urls.TournamentsConnection) === null || _b === void 0 ? void 0 : _b.queryParams.locale }, params)
                });
            }
        },
        GetTournamentWinners: {
            path: (_a) => {
                var _b;
                var { id } = _a, params = __rest(_a, ["id"]);
                return ({
                    channel: `/tournaments/${id}/winners`,
                    params: Object.assign({ lang: (_b = ConfigStore.config.urls.TournamentsConnection) === null || _b === void 0 ? void 0 : _b.queryParams.locale }, params)
                });
            }
        },
        GetOptInTournaments: {
            path: "/optintournaments"
        },
        OptIn: {
            path: (_a) => {
                var { id } = _a, params = __rest(_a, ["id"]);
                return ({
                    channel: `/optintournaments/${id}`,
                    params
                });
            },
            method: "POST"
        },
        GetLeaderboards: {
            path: "/leaderboards"
        }
    }
};
//# sourceMappingURL=index.js.map